export const getFullMonth = (date) => {
    let month = date.getMonth() + 1 + ""
    if (month.length < 2) {
        month = `0${month}`
    }

    return month
}

export const formatDateFull = (date) => {
    const fecha = new Date(date);

    return `${getFullDay(fecha, true)}/${getFullMonth(fecha)}/${fecha.getFullYear()} ${fecha.getHours()}:${fecha.getMinutes()}`
}

export const getFullDay = (date, rest = false) => {
    let day;
    if (rest) {
        day = date.getDate() + ""
    } else {
        day = date.getDate() + 1 + ""
    }
    // let day = date.getDate() + 1 + ""
    if (day.length < 2) {
        day = `0${day}`
    }

    return day
}

export const getNameFromObject = (list, value, fieldName = 'name', esp = false) => {
    let name = ""
    list.map((item) => {
        if (esp) {
            if (item.id == value) {
                name = item[fieldName]
            }
        }

        if (item.value == value) {
            name = item[fieldName]
        }
    })

    return name
}

export const formatCurNumber = (value) => {
    return new Intl.NumberFormat('de-DE').format(value);
}

export const LEVEL_STYLES = {
    inicial: {
        badge: "bg-[#f54487] text-white",
        chip: "bg-[#ffe0ec] text-[#c92a6d]",
    },
    primario: {
        badge: "bg-[#445af5] text-white",
        chip: "bg-[#fff0dc] text-[#b76a18]",
    },
    secundario: {
        badge: "bg-[#eb8a0e] text-white",
        chip: "bg-[#e3efff] text-[#2157b8]",
    },
    terciario: {
        badge: "bg-[#10b981] text-white",
        chip: "bg-[#daf7ed] text-[#11795b]",
    },
    universitario: {
        badge: "bg-[#7c3aed] text-white",
        chip: "bg-[#eee5ff] text-[#5b2eb7]",
    },
    "sin-nivel": {
        badge: "bg-[#64748b] text-white",
        chip: "bg-[#edf2f7] text-[#475569]",
    },
    default: {
        badge: "bg-[#64748b] text-white",
        chip: "bg-[#f4f4f5] text-[#52525b]",
    },
}